<template>
  <header class="w-full z-50 bg-white border-b border-grey-light px-8 py-4">
    <top-bar-resto-admin />
  </header>
</template>

<script>
import TopBarRestoAdmin from './TopBarRestoAdmin';

export default {
  name: 'Header',
  components: {
    TopBarRestoAdmin,
  },
};
</script>
